import React from 'react';

import { useGetProductTemplateConfig } from 'api/api-hooks/product-templates-hooks';
import { GanttChartConfigProps } from 'components/ComponentType';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputSwitch } from 'primereact/inputswitch';
import { TabPanel, TabView } from 'primereact/tabview';
import { T } from 'services/lang/LanguageService';
import GanttRanges from './GanttRanges';
import GanttTimestamps from './GanttTimestamps';

const GanttChartConfig: React.FC<GanttChartConfigProps> = ({ currentConfig, setCurrentConfig }) => {

  const {data} = useGetProductTemplateConfig(
    currentConfig.safeName,
    `${currentConfig.id}`,
    [],
    [],
    {
      enabled: !!currentConfig.safeName && !Number.isNaN(Number(currentConfig.id)),
    }
  );

  return (
    <div>
      <div className="flex justify-content-start gap-3">
        <div className="w-5 md:w-3 gap-2 flex flex-column justify-content-center">
          <label htmlFor="columnOverrideYLabels">{T("word.column-override-y-labels")}</label>
          <Dropdown
            value={currentConfig.columnOverrideYLabels ?? ""}
            options={data?.data?.attributes}
            optionLabel="displayName"
            optionValue="referenceName"
            placeholder={T("word.select-one")}
            showClear
            id="columnOverrideYLabels"
            className="p-inputtext-sm w-14rem"
            onChange={e => setCurrentConfig(prev => ({ ...prev, [e.target.id]: e.target.value }))}
          />
        </div>
        <div className="w-5 md:w-2 gap-2 flex flex-column justify-content-center">
          <label htmlFor="height">{T("word.height")}</label>
          <InputNumber
            id="height"
            value={currentConfig?.height}
            placeholder={T("action.write-value")}
            className="p-inputtext-sm"
            suffix="px"
            onValueChange={e =>
              setCurrentConfig(prev => ({ ...prev, [e.target.id]: e.target.value }))
            }
          />
        </div>
        <div className="w-5 md:w-2 gap-2 flex flex-column justify-content-between align-items-center">
          <label htmlFor="showLegends">{T("word.show-legends")}</label>
          <InputSwitch
            id="showLegends"
            checked={currentConfig?.showLegends ?? true}
            className="p-inputtext-sm mb-2"
            onChange={e =>
              setCurrentConfig(prev => ({ ...prev, [e.target.id]: e.target.value }))
            }
          />
        </div>
        <div className="w-5 md:w-2 gap-2 flex flex-column justify-content-between align-items-center">
          <label htmlFor="aggregateY">{`${T("word.aggregate")} Y`}</label>
          <InputSwitch
            id="aggregateY"
            checked={currentConfig?.aggregateY ?? false}
            className="p-inputtext-sm mb-2"
            onChange={e =>
              setCurrentConfig(prev => ({ ...prev, [e.target.id]: e.target.value }))
            }
          />
        </div>
      </div>
      <TabView className="w-full" panelContainerClassName="px-0">
        <TabPanel header={T("word.time-ranges")}>
          <GanttRanges
            data={data}
            currentConfig={currentConfig}
            setCurrentConfig={setCurrentConfig}
          />
        </TabPanel>
        <TabPanel header={T("word.timestamps")}>
          <GanttTimestamps
            data={data}
            currentConfig={currentConfig}
            setCurrentConfig={setCurrentConfig}
          />
        </TabPanel>
      </TabView>
    </div>
  );
};

export default GanttChartConfig